import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const CENTER_X = 12
const CENTER_Y = 14.6
const DIAL_RADIUS = 8
const TICK_INNER_RADIUS = 8.4
const TICK_OUTER_RADIUS = 10.1
const NEEDLE_ANGLE_DEG = 52
const NEEDLE_LENGTH = 7.6

const pointOnCircle = (cx: number, cy: number, radius: number, degrees: number) => {
    const radians = (degrees * Math.PI) / 180
    return { x: cx + Math.cos(radians) * radius, y: cy - Math.sin(radians) * radius }
}

const dialTicks = Array.from({ length: 9 }, (_, index) => 180 - index * 22.5).map((degrees) => ({
    degrees,
    from: pointOnCircle(CENTER_X, CENTER_Y, TICK_INNER_RADIUS, degrees),
    to: pointOnCircle(CENTER_X, CENTER_Y, TICK_OUTER_RADIUS, degrees)
}))

const needleTip = pointOnCircle(CENTER_X, CENTER_Y, NEEDLE_LENGTH, NEEDLE_ANGLE_DEG)

const technicalsSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
            d={`M ${CENTER_X - DIAL_RADIUS} ${CENTER_Y} A ${DIAL_RADIUS} ${DIAL_RADIUS} 0 0 1 ${CENTER_X + DIAL_RADIUS} ${CENTER_Y}`}
            stroke="currentColor"
            strokeLinecap="round"
        />
        {dialTicks.map((tick) => (
            <line
                key={tick.degrees}
                x1={tick.from.x}
                y1={tick.from.y}
                x2={tick.to.x}
                y2={tick.to.y}
                stroke="currentColor"
                strokeLinecap="round"
            />
        ))}
        <line
            x1={CENTER_X}
            y1={CENTER_Y}
            x2={needleTip.x}
            y2={needleTip.y}
            stroke="currentColor"
            strokeLinecap="round"
        />
        <line x1="6" y1="17.6" x2="18" y2="17.6" stroke="currentColor" strokeLinecap="round" />
        <line x1="8.5" y1="20.2" x2="15.5" y2="20.2" stroke="currentColor" strokeLinecap="round" />
    </svg>
)

const TechnicalsIcon: React.FC<SvgIconProps> = (props) => <SvgIcon {...props}>{technicalsSvg}</SvgIcon>

export default TechnicalsIcon
